import { useStyle } from '@/api/contexts/config/ConfigContext.tsx'
import Color, { type ColorInstance } from 'color'

export function hexToRgb(hex: string): [number, number, number] {
  // Remove the hash if it exists
  hex = hex.replace(/^#/, '')

  // Parse the color components
  const bigint = parseInt(hex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return [r, g, b]
}

export function useColor(hex: string | undefined): ColorInstance {
  const style = useStyle()?.lightBrandingColor ?? '#F15A29'
  try {
    return hex ? Color(hex) : Color(style)
  } catch {
    return Color(style)
  }
}

function isDark(color: ColorInstance) {
  return color.luminosity() < 0.4
}

export function useAltColor(color: ColorInstance): ColorInstance {
  return isDark(color) ? color.lighten(0.6) : color.darken(0.5)
}

export function getTextColorFromLuminance(backgroundColor: string) {
  const [r, g, b] = hexToRgb(backgroundColor)
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5 ? '#000' : '#FFF'
}
